import { createContext } from "react";

const GruposContext = createContext();

export default GruposContext;
